import { render, staticRenderFns } from "./qlBtnA.vue?vue&type=template&id=32692e78&scoped=true"
import script from "./qlBtnA.vue?vue&type=script&lang=js"
export * from "./qlBtnA.vue?vue&type=script&lang=js"
import style0 from "./qlBtnA.vue?vue&type=style&index=0&id=32692e78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32692e78",
  null
  
)

export default component.exports